module.exports = __webpack_public_path__ + "static/media/github.3942fbd8.png";